import { composeRenderProps } from "@ui/primitives/shared";
import { ToggleButton, type ToggleButtonProps } from "@ui/primitives/ToggleButton";
import type { ReactNode } from "react";
import { type ActionPillItemVariants, actionPillItem } from "./action-pill-item.styles";

export interface ActionPillToggleButtonProps extends ToggleButtonProps {
  hoverColor?: ActionPillItemVariants["hoverColor"];
  icon: ReactNode;
  selectedIcon?: ReactNode;
  size?: ActionPillItemVariants["size"];
}

export function ActionPillToggleButton({
  hoverColor = "pink",
  icon,
  selectedIcon,
  size,
  ...props
}: ActionPillToggleButtonProps) {
  return (
    <ToggleButton
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        actionPillItem({ ...renderProps, hoverColor, size, className }),
      )}
    >
      {composeRenderProps(props.children, (children, { isSelected }) => (
        <>
          <span aria-hidden="true" className="inline-flex shrink-0">
            {isSelected && selectedIcon ? selectedIcon : icon}
          </span>
          {children}
        </>
      ))}
    </ToggleButton>
  );
}
